import { inject, isDevMode } from '@angular/core';
import { StorageDebugService } from '../../services';

/**
 * Initializes development debug utilities.
 * Only active in development mode - safe to include in production builds.
 */
export function initializeDebugTools(devMode = isDevMode()) {
  if (!devMode) {
    return;
  }

  const storageDebug = inject(StorageDebugService);
  storageDebug.init();
}
